import { useParentPageContext } from '@/creditflowresearch/application/ParentPageContext';
import { ArticlesType } from '@/creditflowresearch/ui/components/creditFlow/articles/constants';
import UserSubscriptionsContextProvider
  from '@/creditflowresearch/application/Subscriptions/UserSubscriptionsContext/UserSubscriptionsContext';
import ArticlesMarketThemesContextProvider from '@/creditflowresearch/application/ArticlesAndStats/ArticlesMarketThemesContext';
import ArticlesTile from './ArticlesTile';
import capitalize from '@framework/data-helpers/string/capitalize';

import styles from './articlesTiles.module.scss';

export interface IArticlesTilesProps {
  isSubscribeButtonVisible?: boolean,
}

const ArticlesTiles = ({ isSubscribeButtonVisible = true }: IArticlesTilesProps) => {
  const { articlesTilesData: { commentariesList, dealFlowList } } = useParentPageContext();

  return (
    <ArticlesMarketThemesContextProvider>
      <UserSubscriptionsContextProvider>
        <div className={ styles.wrapper }>
          { Object.values(ArticlesType).map((articlesType) => (
            <div className={ styles.tile } key={ articlesType } data-test={ `articlesTile${ capitalize(articlesType) }` }>
              <ArticlesTile
                initialData={ articlesType === ArticlesType.commentary ? commentariesList : dealFlowList }
                themeType={ articlesType }
                isSubscribeButtonVisible={ isSubscribeButtonVisible }
              />
            </div>
          )) }
        </div>
      </UserSubscriptionsContextProvider>
    </ArticlesMarketThemesContextProvider>
  );
};

export default ArticlesTiles;
